import escapeRegExp from './escapeRegExp';
import { WHITESPACE, empty } from './_consts';
export default function trimEnd(str, chars) {
    if (chars !== undefined) {
        chars = escapeRegExp(chars);
    }
    else {
        chars = WHITESPACE;
    }
    const regex = new RegExp(`[${chars}]+$`, 'g');
    return str.replace(regex, empty);
}
